import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { IndicadorArquivoBaixarComponent } from './indicador-arquivo-baixar/indicador-arquivo-baixar.component';
import { IndicadorArquivoRoutingModule } from './indicador-arquivo.routing';
import { IndicadorArquivoService } from './indicador-arquivo.service';


@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule
  ],
  declarations: [
    IndicadorArquivoBaixarComponent
  ],
  exports: [
    IndicadorArquivoRoutingModule,
  ],
  providers: [
    IndicadorArquivoService,
  ]
})
export class IndicadorArquivoModule { }
